import { useState } from "react";
import {
    Avatar,
    // Badge,
    Box,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    Dialog,
    DialogContent,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
// import settinglogo from "../../Assets/Images/SideMenueIcons/Setting-Normal.png";
// import notificationlogo from "../../Assets/Images/SideMenueIcons/Notification-Normal.png";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setProfileData } from "../../Config/Actions/profileActions";


function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const isProfileData = useSelector(state => state.isProfileData)

    const data = isProfileData;

    const [openChangePass, setOpenChangePass] = useState(false);

    const rawTitle = location.pathname.split("/")[2] || location.pathname.split("/")[1] || "Dashboard";

    let formattedTitle = rawTitle.replace(/([a-z])([A-Z])/g, "$1 $2");
    formattedTitle = formattedTitle.replace(/[+\-*/]/g, " ");
    formattedTitle = formattedTitle.charAt(0).toUpperCase() + formattedTitle.slice(1);


    const userName = data?.data?.fullName || "User";
    const userImage = data?.data?.fullName

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        navigate("/login");
        dispatch(setProfileData(null));
    };

    const handleChangePassword = () => {
        handleClose();
        setOpenChangePass(true);
    };


    return (
        <Box
            bgcolor="#ffffff"
            className="w-100 sidemenue px-3 d-flex align-items-center justify-content-between"
            zIndex="2"
            height="64px"
        >
            <Typography variant="h5">{formattedTitle}</Typography>

            <Box className="d-flex align-items-center gap-3">
                {/* <IconButton>
                    <Badge badgeContent={2} className="badge p-0 pt-1">
                        <img height="24px" src={settinglogo} alt="" />
                    </Badge>
                </IconButton>

                <IconButton>
                    <Badge badgeContent={2} className="badge p-0 pt-1">
                        <img height="24px" className="p-0" src={notificationlogo} alt="" />
                    </Badge>
                </IconButton> */}

                <Box className="user d-flex gap-2 me-2 align-items-center">
                    <Avatar className="text-center" sx={{ bgcolor: "black" }}>
                        {!userImage && userName.charAt(0).toUpperCase()}

                    </Avatar>
                    <Box>
                        <Typography>{userName}</Typography>
                    </Box>
                    <IconButton onClick={handleMenuClick}>
                        <KeyboardArrowDown />
                    </IconButton>
                </Box>

                {/* Dropdown Menu */}
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    {/* <MenuItem onClick={handleChangePassword}>Change Password</MenuItem> */}
                </Menu>

                {/* <LoggedUser /> */}

            </Box>

            {/* Dialog with ChangePassword form */}
            <Dialog
                className="changepass"
                open={openChangePass}
                onClose={() => setOpenChangePass(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    {/* <ChangePassword onClose={() => setOpenChangePass(false)} /> */}
                </DialogContent>
            </Dialog>

        </Box>
    );
}

export default Header;
